export const sr = {
    'nav.today': "Pregled Danas",
    'nav.calendar': "Kalendar Potražnje",
    'nav.rates': "Cene i Pravila",
    'nav.automation': "Automatizacija",
    'nav.audit': "Dnevnik Revizije",
    'nav.settings': "Podešavanja",
    'sidebar.status': "Povezano",
    'stat.occupancy': "Popunjenost",
    'stat.adr': "Prosečna Cena (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Proc. Prihod",
    'stat.trend.vsLastWeek': "vs Prošla Ned.",
    'stat.trend.onPace': "U skladu sa planom",
    'dashboard.actions.title': "Preporučene Akcije",
    'dashboard.actions.empty': "Nema akcija.",
    'filter.all': "Sve",
    'filter.pricing': "Cene",
    'filter.restriction': "Restrikcije",
    'action.approve': "Odobri",
    'action.reject': "Odbij",
    'action.risk.low': "nizak rizik",
    'action.risk.medium': "srednji rizik",
    'action.risk.high': "visok rizik",
    'action.label.current': "Trenutno",
    'action.label.proposed': "Predloženo",
    'action.metric.impact': "Uticaj",
    'action.metric.why': "Zašto",
    'action.status.executed': "Auto-Izvršeno",
    'header.search': "Pretraga...",
    'header.logout': "Odjavi se",
    'auto.level.title': "Nivo Autopilota",
    'auto.level.manual': "Ručno",
    'auto.level.manual.desc': "Odobravate svaku preporuku.",
    'auto.level.assisted': "Asistirano",
    'auto.level.assisted.desc': "Auto-odobri nizak rizik. Pregledaj velike promene.",
    'auto.level.auto': "Potpuno Automatski",
    'auto.level.auto.desc': "AI upravlja cenama 24/7 unutar vaših granica.",
    'auto.level.active': "Aktivan",
    'auto.guardrails.title': "Sigurnosne Granice",
    'auto.guardrails.maxIncrease': "Maks. Dnevno Povećanje",
    'auto.guardrails.maxIncrease.desc': "Spreči šokove cena.",
    'auto.guardrails.maxDecrease': "Maks. Dnevno Smanjenje",
    'auto.guardrails.maxDecrease.desc': "Spreči preveliko spuštanje cena.",
    'auto.guardrails.minRate': "Minimalna Cena",
    'auto.guardrails.minRate.desc': "Nikad ne prodaj ispod ove cene (Neto).",
    'auto.emergency.title': "Hitna Kontrola",
    'auto.emergency.label': "Hitno Zaustavljanje",
    'auto.emergency.desc': "Odmah pauziraj svu automatizaciju.",
    'auto.emergency.btn': "PAUZIRAJ SISTEM",
    'rates.filter.all': "Svi Tipovi Soba",
    'rates.filter.next14': "Narednih 14 Dana",
    'rates.export': "Izvezi",
    'audit.table.time': "Vreme",
    'audit.table.actor': "Korisnik",
    'audit.table.category': "Kategorija",
    'audit.table.action': "Akcija",
    'audit.table.details': "Detalji",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS Veza",
    'settings.pms.connected': "Povezano sa",
    'settings.pms.disconnect': "Prekini Vezu",
    'settings.account.title': "Nalog",
    'settings.account.role': "Uloga",
    'settings.restart': "Ponovi Onboarding",
    'onboard.title': "Poveži PMS",
    'onboard.desc': "Izaberite svoj PMS sistem za sinhronizaciju.",
    'onboard.connecting': "Povezivanje...",
    'onboard.connect': "Poveži",
    'onboard.success.title': "Podešavanje Završeno!",
    'onboard.success.desc': "**SynthHotel Berlin** je sada sinhronizovan.",
    'onboard.success.sub': "Uvezeno 3 tipa soba, 14 cenovnika i 243 rezervacije.",
    'onboard.btn.dashboard': "Idi na Kontrolnu Tablu",
    'action.dynamic.weekend.title': "Povećaj Cenu za Vikend",
    'action.dynamic.weekend.desc': "Popunjenost > 75% subota, jaka potražnja (+12 soba za 24h).",
    'action.dynamic.minstay.title': "Aktiviraj Min. Boravak 2 Noći",
    'action.dynamic.minstay.desc': "Najavljen koncert Taylor Swift. Spreči boravak od 1 noći.",
    'action.dynamic.distress.title': "Smanji Cenu (Slaba Potražnja)",
    'action.dynamic.distress.desc': "Popunjenost 35% sledeći utorak. Konkurencija spustila za €10.",
    'action.dynamic.gap.title': "Popuni Prazninu: Ukloni CTA",
    'action.dynamic.gap.desc': "Praznina od jedne noći. Ukloni 'Zatvoreno za Dolazak' radi prodaje.",
};
